// extracted by mini-css-extract-plugin
export var centerText = "_d8-8";
export var container = "_d8-0";
export var doughnutContainer = "_d8-7";
export var legend = "_d8-a";
export var legendItemColorDisplay = "_d8-b";
export var legendItemLabel = "_d8-d";
export var legendItemValue = "_d8-c";
export var lg = "_d8-5";
export var maxWidth = "_d8-9";
export var md = "_d8-4";
export var responsive = "_d8-6";
export var sm = "_d8-3";
export var xs = "_d8-2";
export var xxs = "_d8-1";